export const KEY = "acceptedDialogByMenuKey";
import { storage } from "./storage";

/**
 * Storageオブジェクトをラップしたインターフェース
 */
export type Storage = {
  get: (key: string) => string[] | undefined;
  set: (key: string, value: string[]) => void;
};

type _Get = (storage: Storage) => () => string[];
type _Save = (storage: Storage, get: () => string[]) => (value: string) => void;

/**
 * storageから指定したキーを元に値を取得する
 *
 * @param storage Storage オブジェクト
 * @returns お届け日ごとのダイアログの承諾済み判定
 */
export const _get: _Get = (storage) => () => {
  const values: string[] | undefined = storage.get(KEY);
  return values !== undefined ? values : [];
};

/**
 * storageに値を保存する
 *
 * @param storage Storage オブジェクト
 */
export const _save: _Save = (storage, get) => (value): void => {
  const values = [value, ...get()].filter(
    (value, index, array) => array.indexOf(value) === index
  );
  storage.set(KEY, values);
};

export const get = _get(storage);
export const save = _save(storage, get);
